import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useState, useRef, useEffect } from 'react';
import './index.scss';
import { Bubble, Dropdown, List } from 'tea-component';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';
import GameImage from '@/pages/home/components/GameImage';
import { addV2Prefix } from '@/pages/intelligence/utils/commonUtils';
import TipOne from '@/pages/intelligence/assets/svg/tipicon/tip-one.svg';
import TipTwo from '@/pages/intelligence/assets/svg/tipicon/tip-two.svg';
import TipThree from '@/pages/intelligence/assets/svg/tipicon/tip-three.svg';
import _ from 'lodash-es';

interface GameCvmType {
  /** 头像src */
  img: string;
  /** 竖着头像图标 */
  icon?: any; // ??
  /** 标题 */
  gametitle: string;
  /** 主题标题 */
  isDatabrain?: string;
  databrainIconTip?: React.ReactNode;
  /** 文字前面的图标列表 */
  iconList?: any[];
  /** 国家图标 */
  countryIcon?: string;
  /** 描述 */
  text?: React.ReactNode;
  // 描述是否有气泡
  hasTextBubble?: boolean;
  /** 描述提示列表 */
  tipList?: any[];
  /* 前面图标 */
  frontIcon?: string;
  /** 类名*/
  className?: string;
  imgType?: string; // 默认是正方形圆角 1是横向长方形 2是纵轴长方形

  customIcon?: string | null | React.ReactNode;
  entityIcon?: string | null | React.ReactNode;
}
interface FirstRowProps {
  cvm: GameCvmType;
  /** id显示 如排名 */
  id?: number | string;
  // 排名是否有徽章效果，详见genre profile - insights - Market CR10 By Revenue
  hasBadge?: boolean;
  // 是否需要展示图片。默认展示图片
  showImg?: boolean;
  /** 是否显示下拉，下拉显示的数据 */
  popupData?: any[];
  className?: string;
  /** 右键游戏跳转新链接 */
  rihgtClickToJumpHref?: string;
  onClick?: (...args: any[]) => void;
  // 下拉点击回调
  onDropdown?: (...args: any[]) => void;
  // 点击图片打开下拉
  clickImageOpenDropdown?: boolean
}

const RANK_ICONS = [TipOne, TipTwo, TipThree];
const FirstRow = (props: FirstRowProps) => {
  const {
    showImg = true,
    cvm,
    id,
    hasBadge,
    popupData,
    rihgtClickToJumpHref,
    className,
    onClick,
    onDropdown,
    clickImageOpenDropdown= false
  } = props;
  // console.log('FirstRowFirstRow', props);
  const dropDown = useRef<HTMLDivElement>(null);
  const popover = useRef<HTMLDivElement>(null);
  const rank = Number(id);

  const [openDropdown, setOpenDropdown] = useState(false);

   // 点击目标元素外面判断是否关闭弹层
   const handleOutSideClick = (e: Event) => {
    // 判断点击元素是否在Dropdown组件内
    if (dropDown?.current?.contains(e.target as HTMLElement)) return;

    // 判断点击元素是否在弹层内
    if (popover?.current?.contains(e.target as HTMLElement)) return;

    setOpenDropdown(false);
  };

  useEffect(() => {
    document.addEventListener('click', handleOutSideClick, true);

    return () => {
      document.removeEventListener('click', handleOutSideClick, true);
    };
  }, [handleOutSideClick]);
  return (
    <ARightClickToJump
      href={addV2Prefix(rihgtClickToJumpHref)}
      style={{ display: 'inline' }}
    >
      <div
        className={`dbi-firstRow-flex ${className ? className : ''}`}
        onClick={() => {
          if (onClick instanceof Function) {
            onClick();
          }
        }}
      >
        {id ? (
          rank && hasBadge ? (
            <div className="dbi-gameinfocont-rank">
              {rank > 0 && rank <= 3 ? (
                <img src={RANK_ICONS[rank - 1]} alt="" />
              ) : (
                <span>{rank}</span>
              )}
            </div>
          ) : (
            <span className="dbi-text-id">{id}</span>
          )
        ) : (
          ''
        )}
        {cvm?.frontIcon ? (
          <img src={cvm?.frontIcon} className="dbi-firstRow-front" />
        ) : (
          ''
        )}
        {/* {cvm?.img ? (
          <GameImage
            src={cvm?.img}
            entityType={cvm?.imgType}
            className={
              cvm?.imgType == 'pc'
                ? 'dbi-firstRow-imgtwo'
                : cvm?.imgType == 'console'&& cvm?.icon
                ? 'dbi-firstRow-imgthere big-img'
                : cvm?.imgType == 'console' 
                ? 'dbi-firstRow-imgthere'
                : 'dbi-firstRow-imgone'
            }
          />
        ) : (
          ''
        )} */}
        {showImg && (
          <GameImage
            onClick={()=> clickImageOpenDropdown && setOpenDropdown(true)}
            src={cvm?.img}
            entityType={cvm?.imgType}
            className={
              cvm?.imgType == 'pc'
                ? 'dbi-firstRow-imgtwo'
                : cvm?.imgType === 'mobile'
                ? 'dbi-firstRow-imgone'
                : (cvm?.icon && cvm?.imgType !== 'company') || cvm?.imgType == 'console'|| cvm?.imgType == 'combine'
                ? 'dbi-firstRow-imgthere big-img '
                : 'dbi-firstRow-imgone'
            }
          />
        )}
        <div className="dbi-firstRow-gametitle">
          <div className="dbi-firstRow-gametitle-flex">
            <a className="dbi-firstRow-title">
              {/* 主题图标， 以防icon不一样，所以传入 */}
              {/* {cvm?.isDatabrain ? (
                <Bubble content={cvm?.databrainIconTip}>
                  <label className='dbi-firstRow-themeBtn'><img
                    src={cvm?.isDatabrain}
                    className="dbi-firstRow-theme"
                  /></label>
                </Bubble>
              ) : null} */}
              {!_.isEmpty(popupData) ? (
                <Dropdown
                  ref={dropDown}
                  className={`dbi-firstRow-title-dropdown ${
                    openDropdown ? 'dropdown-open' : ''
                  }`}
                  trigger="click"
                  placementOffset={[0, 0]}
                  clickClose={false}
                  open={openDropdown}
                  // @ts-ignore
                  onClick={()=> setOpenDropdown(!openDropdown)}
                  button={cvm?.gametitle}
                  // onOpen={() => setOpenDropdown(true)}
                  // onClose={() => setOpenDropdown(false)}
                >
                  <div ref={popover}>
                    <List type="option" >
                      {popupData?.map((item: any) => (
                        <List.Item
                          onClick={() => {
                            onDropdown?.(item);
                            setOpenDropdown(false);
                          }}
                          key={item.value}
                        >
                          {item.text}
                        </List.Item>
                      ))}
                    </List>
                  </div>
                 
                </Dropdown>
              ) : (
                <span>{cvm?.gametitle}</span>
              )}
            </a>
          </div>

          <div className="dbi-firstRow-right">
            {cvm?.iconList ? (
              <div className="dbi-firstRow-desc">
                {cvm?.iconList.map((item: any, index: number) => (
                  <SvgIcon
                    key={index}
                    type={item}
                    className="dbi-firstRow-desc-svg"
                  />
                ))}
              </div>
            ) : (
              ''
            )}
            {cvm?.customIcon ? cvm?.customIcon : null}
            {cvm?.countryIcon ? (
              <img src={cvm?.countryIcon} className="dbi-firstRow-svg" />
            ) : (
              ''
            )}
            {cvm?.text ? (
              cvm?.hasTextBubble ? (
                <Bubble
                  className="dbi-firstRow-bubble"
                  dark
                  content={cvm?.text}
                >
                  <span className="dbi-firstRow-text">{cvm?.text}</span>
                </Bubble>
              ) : (
                <span className="dbi-firstRow-text">{cvm?.text}</span>
              )
            ) : (
              ''
            )}
            {cvm?.tipList ? (
              <span className="dbi-firstRow-box">
                {cvm?.tipList?.map((e: any, i: any) => (
                  <span className="dbi-firstRow-text-tip" key={i}>
                    {e}
                  </span>
                ))}
              </span>
            ) : (
              ''
            )}
            {/* 主题图标， 以防icon不一样，所以传入 */}
            {cvm?.isDatabrain ? (
              <Bubble
                style={{ maxWidth: 400 }}
                className="dbi-firstRow-bubble"
                dark
                content={cvm?.databrainIconTip}
              >
                <label className="dbi-firstRow-themeBtnafter">
                  <img src={cvm?.isDatabrain} className="dbi-firstRow-theme" />
                </label>
              </Bubble>
            ) : null}
          </div>
          {/* {cvm?.icon ? (
            <div className="dbi-firstRow-icon">
              {cvm?.icon.map((item: any, index: number) =>
                item ? (
                  <img src={item} className="dbi-firstRow-show" key={index} />
                ) : null,
              )}
            </div>
          ) : (
            ''
          )} */}
          {(!!cvm?.icon || !!cvm?.entityIcon) && (
            // cvm?.icon 为数组，按数组方式渲染
            <div className="dbi-firstRow-icon">
              {!!cvm?.entityIcon ? cvm?.entityIcon : null}
              {!!cvm?.entityIcon && !!cvm?.icon && (
                <span className="dbi-firstRow-split"></span>
              )}
              {Array.isArray(cvm?.icon) &&
                cvm?.icon
                  ?.filter((item) => !!item)
                  ?.map((item: any, index: number) => {
                    return (
                      <img
                        src={item}
                        className="dbi-firstRow-show"
                        key={index}
                      />
                    );
                  })}
              {/* 否则按单个icon方式渲染 */}
              {typeof cvm?.icon === 'string' && (
                <img
                  src={cvm?.icon}
                  className="dbi-firstRow-show"
                  key={cvm?.icon}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </ARightClickToJump>
  );
};

export default FirstRow;
